import { Skademeldingstype, SporsmalId } from '../types/generated-types';
import { assertUnreachable } from './compiler-utils';

export const dataTrackIdPrefix = 'forsikring-meld-skade';

export enum SideType {
    Kategoriside = 'Kategoriside',
    Skjemaside = 'Skjemaside',
    Oppsummeringsside = 'Oppsummeringsside',
    Utloggetside = 'Utloggetside',
}

export interface Kategoriside {
    type: SideType.Kategoriside;
    kategoriId: string;
}

export interface Skjemaside {
    type: SideType.Skjemaside;
    skademeldingstype: Skademeldingstype | string;
    currentSporsmalId?: SporsmalId | string;
}

export interface Utloggetside {
    type: SideType.Utloggetside;
    skademeldingstype: Skademeldingstype | string;
}

export interface Oppsummeringsside {
    type: SideType.Oppsummeringsside;
    skademeldingstype: Skademeldingstype | string;
}

export type SideDetail = Kategoriside | Skjemaside | Oppsummeringsside | Utloggetside;

export const generateDataTrackIdForAction = (actionId: string, sideDetail: SideDetail): string => {
    switch (sideDetail.type) {
        case SideType.Kategoriside:
            return `${dataTrackIdPrefix}-kategoriside-${sideDetail.kategoriId}-${actionId}`;
        case SideType.Skjemaside:
            if (sideDetail.currentSporsmalId !== undefined) {
                return `${dataTrackIdPrefix}-skjemaside-${
                    sideDetail.skademeldingstype
                }-${sideDetail.currentSporsmalId.replace(/_/g, '')}-${actionId}`;
            }
            return `${dataTrackIdPrefix}-skjemaside-${sideDetail.skademeldingstype}-${actionId}`;

        case SideType.Oppsummeringsside:
            return `${dataTrackIdPrefix}-skjemaside-${sideDetail.skademeldingstype}-oppsummering-${actionId}`;
        case SideType.Utloggetside:
            return `${dataTrackIdPrefix}-utloggetside-${sideDetail.skademeldingstype}-${actionId}`;
        default:
            return assertUnreachable(sideDetail);
    }
};

export const generateDataTrackIdForButtonOnKategoriside = (kategoriId: string, buttonId: string): string =>
    `${dataTrackIdPrefix}-kategoriside-${kategoriId}-${buttonId.replace(/_/g, '')}-link`;
